import { Component, OnInit, Input } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { InspectionAdditionalObservationImagesVM, InspectionAdditionalObservationListsViewModel, PopupEndPoint } from '../../../inspection/models/create-inspection.model';
import { LoadingService } from '../../../../shared/services/loading.service';
import {  ViewPhotoComponent } from '../view-photo/view-photo.component';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer } from '@angular/platform-browser';
import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
import { NewObservationListPropertyComponent } from '../../../inspection/add-inspection-observation-lists/new-observation-list-property/new-observation-list-property.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { AdditionalComponentAnswerComponent } from '../additional-component-answer/additional-component-answer.component';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'inspection-additional-observation',
  templateUrl: './inspection-additional-observation.component.html',
  styleUrls: ['./inspection-additional-observation.component.scss'],
  animations: [
    trigger(
      'slideOut', [
        transition(':enter', [
          style({ 'max-height': '0' }),
          animate('5s', keyframes([
            style({ 'max-height': '200px', offset: 0 }),
            style({ 'max-height': '400px', offset: 0.3 }),
            style({ 'max-height': '600px', offset: 0.6 }),
            style({ 'max-height': '1400px', offset: 0.9 }),
          ]))
        ])
      ]
    )],
})
export class InspectionAdditionalObservationComponent implements OnInit {

  @Input() inspectionId: number;
  @Input() PopupEndPoint: PopupEndPoint; // .InspectionObservationList;

  observationLists: InspectionAdditionalObservationListsViewModel[];



  constructor(
    private _interp: InterpretationService,
    private _loading: LoadingService,
    private _dialog: MatDialog,
    private _sanitizer: DomSanitizer,
    ) { }



  ngOnInit() {
    this.loadObservationLists();
    console.log(this.PopupEndPoint);
  }

  viewObservationListPhoto(observation: InspectionAdditionalObservationListsViewModel,imageData:InspectionAdditionalObservationImagesVM) {
    const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
      data: {
        comingFrom: this.PopupEndPoint,
        observationList: observation,
        imageData:imageData
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(reloadPhoto => {
      if (reloadPhoto) {
        this.loadObservationLists();
      }
    });
  }

  // editObservationListComment(observation: InspectionAdditionalObservationListsViewModel) {
  // }

  EditObservation(obs:InspectionAdditionalObservationListsViewModel){
    console.log("Data", obs);
    const dialogRef = this._dialog.open(ConfirmDialogComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        inspectionId: this.inspectionId,
        obsId:obs.Id,
        Title:obs.Title,
        isEdit:true,
        observationLists: this.observationLists
      }
    });

    dialogRef.afterClosed().subscribe(added => {
      if (added) {
        this.loadObservationLists();
      }
    });
  }

  AnswerAdditonalObs(obs:InspectionAdditionalObservationListsViewModel){
    console.log("Data", obs);
    const dialogRef = this._dialog.open(AdditionalComponentAnswerComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        InspectionAdditionalObsId: obs.Id,
        AdditionalObsRefId: obs.ReferenceId,
        AnswerList:obs.AnswerList,
        QuestionTypeId:obs.QuestionTypeId,
        isCreateNew:false,
      }
    });

    dialogRef.afterClosed().subscribe(added => {
      if (added) {
        this.loadObservationLists();
      }
    });
  }
  AddNewObservationList() {
    const dialogRef = this._dialog.open(NewObservationListPropertyComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        inspectionId: this.inspectionId,
        createfromObsList:false,
        additionalObservationListCheck: this.observationLists
      }
    });

    dialogRef.afterClosed().subscribe(edit => {
      if (edit==true) {
        this.loadObservationLists();
      }
    });
  }

  loadObservationLists() {
    this._loading.startLoading();
    this._interp.GetAllAdditionalObservationLists(this.inspectionId).subscribe(r => {
      console.log(r);
      this.observationLists = r;
      this._loading.finishedLoading();
    });
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  reloadObservationLists() {
    this.loadObservationLists();
  }


  
  reloadObservatioComment(obs:InspectionAdditionalObservationListsViewModel){
    this._interp.GetInspectionObservationListComment(obs.Id).subscribe(res=>{
     
        obs.Comment = res;
      
    })
        //component.Comment = this.updateComment;
       
      }

      reloadObservationPhoto(obs:InspectionAdditionalObservationListsViewModel){
        this._interp.GetInspectionObservationListImageList(obs.Id).subscribe(res=>{
         
            obs.ObsImages = res;
          
        })
            //component.Comment = this.updateComment;
           
          }
  OpenDeleteAdditionalObs(obsId:number){
    const viewPhotoModalRef = this._dialog.open(ConfirmDialogComponent, {
      data: {
        isEdit:false,
       
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(res => {
      if (res==true) {
      this.DeleteAdditionaObs(obsId);
       
        }
      });
  }


  DeleteAdditionaObs(obsId:number){
    this._interp.DeleteAdditionalObsPoint(this.inspectionId, obsId).subscribe(res=>{
      if(res.m_Item1==true){
        this.loadObservationLists();
      }
    })
  }
}


